export default __webpack_public_path__ + "static/media/poster2.f6708b24.png";